// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-223464fc]{font-size:11px;line-height:1.4545454;display:flex;align-items:flex-start;color:var(--color-red-primary)}.error .svg-icon[data-v-223464fc]{font-size:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
